module.exports = __webpack_public_path__ + "static/thumbnail-38ea386fbf95b54b93ee8431ef49ccd8.jpg";